import * as tslib_1 from "tslib";
import * as React from 'react';
import strings from 'owa-strings/owa-options-strings';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { OptionDescription } from 'owa-options-controls';
var AdvancedSecurityOptionFull = /** @class */ (function (_super) {
    tslib_1.__extends(AdvancedSecurityOptionFull, _super);
    function AdvancedSecurityOptionFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdvancedSecurityOptionFull.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", null,
                React.createElement(OptionDescription, null, strings.options_premium_AdvancedSecurityContent_part1),
                React.createElement("div", null,
                    React.createElement(Link, { href: "https://aka.ms/outlookcomadvancedsecurityfaq", target: "_blank" }, strings.options_premium_AdvancedSecurityContent_LearnMore)))));
    };
    return AdvancedSecurityOptionFull;
}(React.Component));
export default AdvancedSecurityOptionFull;
//# sourceMappingURL=AdvancedSecurityOptionFull.js.map